import { render, staticRenderFns } from "./advantageTrain.vue?vue&type=template&id=29b510e3&scoped=true"
import script from "./advantageTrain.vue?vue&type=script&lang=js"
export * from "./advantageTrain.vue?vue&type=script&lang=js"
import style0 from "./advantageTrain.vue?vue&type=style&index=0&id=29b510e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b510e3",
  null
  
)

export default component.exports